var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21q-.349 0-.713-.127a1.65 1.65 0 0 1-.637-.408l-1.725-1.604a69 69 0 0 1-4.788-4.9Q2.002 11.528 2 8.6q0-2.393 1.575-3.997T7.5 3q1.325 0 2.5.573t2 1.566a6 6 0 0 1 2-1.566A5.6 5.6 0 0 1 16.5 3q2.35 0 3.925 1.604T22 8.601q0 2.928-2.125 5.372a60 60 0 0 1-4.825 4.914l-1.7 1.578a1.65 1.65 0 0 1-.637.408Q12.35 21 12 21m-.95-13.825q-.725-1.044-1.55-1.59-.825-.548-2-.548-1.5 0-2.5 1.018-1 1.02-1 2.546 0 1.324.925 2.813a19.4 19.4 0 0 0 2.213 2.89 39 39 0 0 0 2.65 2.622Q11.15 18.15 12 18.938q.85-.79 2.213-2.012a39 39 0 0 0 2.65-2.622 19.4 19.4 0 0 0 2.212-2.89Q20 9.926 20 8.601q0-1.527-1-2.546t-2.5-1.018q-1.175 0-2 .547t-1.55 1.591a1.15 1.15 0 0 1-.95.51 1.14 1.14 0 0 1-.95-.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteHeartOutline);
export default __webpack_public_path__ + "static/media/favorite_heart_outline.580d31a5caa7510b7374a42bca9c8767.svg";
export { ForwardRef as ReactComponent };